import Highcharts from "highcharts"
import HighchartsReact from "highcharts-react-official"
import { useAppSelector } from "../../util/hooks"
import { MODEL_META_DATA_CARDS } from "../../util/StaticData"
import { IModelMetaDataCard } from "../../util/interface"
import { Box } from "@mui/material"
import { useEffect } from "react"

const HighChartsLineChart = () => {
  const chartData = useAppSelector((store) => store.modelMetaData.chartData)
  const activeTabText = useAppSelector((store) => {
    return MODEL_META_DATA_CARDS.find(
      (obj: IModelMetaDataCard) => obj.key == store.modelMetaData.activeTab,
    )?.title
  })

  const chartViewBySelectedValue = useAppSelector(
    (store) => store.modelMetaData.chartViewBySelectedValue,
  )
  const monthMapper: any = {
    month: "Month",
    week: "Week",
  }
  const options = {
    chart: {
      type: "spline",
    },
    title: {
      text: "",
    },
    subtitle: {},
    credits: {
      enabled: false,
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          verticalAlign: "bottom",
          align: "left",
          format: "{y} %",
        },
      },
    },
    tooltip: {
      valueSuffix: "%",
    },
    xAxis: {
      categories: structuredClone(chartData.categories),
      gridLineWidth: 1,
      title: {
        text: monthMapper[chartViewBySelectedValue],
      },
    },
    yAxis: {
      title: {
        text: activeTabText,
      },
      gridLineWidth: 1,
      labels: {
        formatter: (obj: any) => {
          return `${obj.value}%`
        },
      },
    },
    series: [
      {
        name: "Before Retraining",
        data: structuredClone(chartData.beforeRetrain),
        color: "#777777",
        marker: {
          symbol: "circle",
        },
      },
      {
        name: "After Retraining",
        data: structuredClone(chartData.afterRetrain),
        color: "#E81C0E",
        marker: {
          symbol: "circle",
        },
      },
    ],
  }

  useEffect(() => {}, [chartData])
  return (
    <Box sx={{ height: "100%" }}>
      <>
        {chartData?.afterRetrain && chartData?.beforeRetrain ? (
          <HighchartsReact
            highcharts={Highcharts}
            options={options}
            constructorType={"chart"}
          />
        ) : (
          ""
        )}
      </>
    </Box>
  )
}

export default HighChartsLineChart
